
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1.254","y":".903","width":"9.167","height":"9.167","rx":"3.75","stroke":"#56BFC7","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"1.254","y":"14.236","width":"9.167","height":"9.167","rx":"3.75","stroke":"#56BFC7","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"14.59","y":".903","width":"9.167","height":"9.167","rx":"3.75","fill":"#56BFC7","stroke":"#56BFC7","stroke-width":"1.5"}}),_c('rect',{attrs:{"x":"14.59","y":"14.236","width":"9.167","height":"9.167","rx":"3.75","stroke":"#56BFC7","stroke-width":"1.5"}})])
          )
        }
      }
    